/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

// 環境変数から取得、なければデフォルト値を使用（開発用）
export const projectId = process.env.REACT_APP_SUPABASE_PROJECT_ID || "cxwhcpfwhzlfnncuhtdf"
export const publicAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "sb_publishable_W49J7fBqKmNab9WquH7FQw_IwbeteQL"